import { useLocation, useNavigate, useParams } from "react-router";
import {
	findRouteKey,
	isValidLang,
	type Lang,
	ROUTE_SLUGS,
} from "@/config/routes";

export function useLanguageSwitcher() {
	const { lang } = useParams<{ lang: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const currentLang: Lang = lang && isValidLang(lang) ? lang : "pl";

	return (newLang: Lang) => {
		const segments = location.pathname.split("/").filter(Boolean);
		// segments[0] is the lang prefix, segments[1] is the slug
		const currentSlug = segments[1] ?? "";
		const routeKey = findRouteKey(currentSlug, currentLang);
		const newSlug = routeKey ? ROUTE_SLUGS[routeKey][newLang] : currentSlug;
		const rest = segments.slice(2).join("/");
		const parts = [`/${newLang}`, newSlug, rest].filter(Boolean);
		navigate(parts.join("/") + location.search);
	};
}
